import { Box, CardMedia, ListItemButton, Typography } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import { makeStyles } from 'tss-react/mui'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface SarchCardProps {
  productId: string
  image?: string
  title: string
  productNumber: string
  handleProductClick: (productId: string) => void
}

const useStyles = makeStyles()(theme => ({
  cardContainer: {
    display: 'flex',
    minWidth: '350px',
    maxWidth: '350px',
    gap: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.shades.shade03}`,
  },
  productContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  productTitle: {
    whiteSpace: 'nowrap',
    width: '262px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  productPrice: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
}))

/*
 * This is the product card on the search Popover
 */
const SearchCard: React.FC<SarchCardProps> = ({ image, title, productNumber, productId, handleProductClick }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const [showTooltip, setShowTooltip] = useState<boolean>(false)
  const titleRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (titleRef.current) {
      setShowTooltip(titleRef.current.scrollWidth > titleRef.current.clientWidth)
    }
  }, [title])

  return (
    <ListItemButton
      onClick={() => {
        handleProductClick(productId)
      }}
      className={classes.cardContainer}
    >
      <CardMedia component="img" sx={{ width: '48px', height: 'auto', minWidth: '48px' }} image={image} />
      <Box className={classes.productContainer}>
        <OptionalTooltipWrapper titleKey={title} hasTooltip={showTooltip}>
          <Typography variant="body2" ref={titleRef} className={classes.productTitle}>
            {title}
          </Typography>
        </OptionalTooltipWrapper>
        <Box className={classes.productPrice}>
          <Typography variant="subtitle1">{t('shop.search.serial-number-label')}:</Typography>
          <Typography color="inherit" variant="subtitle2" sx={{ marginLeft: '6px' }}>
            {productNumber}
          </Typography>
        </Box>
      </Box>
    </ListItemButton>
  )
}

export default SearchCard
